// ../ui/StatusBadge
import { Button } from 'antd';
import dayjs from 'dayjs';
import { DashbordTopBar } from 'features/Dashboard/components/top-bar/dashboard-top';
import { StatusBadge } from 'features/Dashboard/ui/StatusBadge';
import { useGetLegalDashBaordList } from 'features/Dashboard/use-cases/get-dashboardId';
import { useUserContext } from 'features/users';
import { FileText, RotateCcw } from 'lucide-react';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// ../use-cases/get-dashboardId
const DashBoardView = () => {
  const { user, menuItem } = useUserContext();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [titleDocuments, setTitleDocuments] = useState('');
  const { data, refetch } = useGetLegalDashBaordList(user?.CompanyId);
  const [isload, setIsLoad] = useState(false);

  // Progress calculation
  const uploadedDocuments =
    data?.rc.filter((doc: any) => doc.documentPath).length ?? 0;
  const totalDocuments = 4;
  const uploadProgress = Math.round((uploadedDocuments / totalDocuments) * 100);
  const handleClickRefresh = async () => {
    try {
      setIsLoad(true); // Start loading
      await refetch(); // Wait for `intialFetch` to complete
    } catch (error) {
      console.error('Error during refresh:', error); // Handle errors
    } finally {
      setIsLoad(false); // Stop loading regardless of success or error
    }
  };
  useEffect(() => {
    if (menuItem?.rc[0]?.Url === 'management-report') {
      navigate('/management-report');
    }
  }, [menuItem?.rc[0]?.Url, navigate]);

  return (
    <Fragment>
      <DashbordTopBar
        setShowModal={setShowModal}
        titleDocuments={titleDocuments}
        showModal={showModal}
        refetch={refetch}
      />
      <div className=''>
        <div className='flex gap-3'>
          <img
            src={
              user?.ClientImage ||
              'https://cdn-icons-png.flaticon.com/512/3135/3135715.png'
            }
            alt='Client'
            className='w-16 h-16  border-gray-200 border-solid'
          />
          <span className='mt-0'>
            <p className='text-xl font-bold text-blue-900 mb-2'>
              Welcome to {user?.Name}
            </p>
            <p className='text-green-600 text-sm bg-[#D7E8D3] inline px-3 py-1 rounded-2xl'>
              Currently Active
            </p>
          </span>
        </div>
        <div className='bg-white p-4 mt-5 px-6'>
          <div className='flex justify-between items-center sm:gap-4 md:gap-4'>
            <div className='w-9/12'>
              <h3
                className='text-2xl font-bold
              2xl:text-5xl
              xl:text-4xl
              lg:text-3xl
              md:text-lg
              sm:text-lg
              '
              >
                Your Profile is Almost Here!
              </h3>
              <p className='text-gray-600'>
                Complete your profile by uploading the needed documents
              </p>
            </div>

            {/* <div className='rounded-full border-4 border-gray-200 border-solid w-24 h-24 flex justify-center items-center text-2xl'
              // style={
              //   {
              //     '--value': uploadProgress,
              //     '--size': '4rem',
              //     '--thickness': '0.5rem',
              //   } as React.CSSProperties & { [key: string]: string | number }
              // }
            >
              {uploadProgress}%
            </div> */}

            <div className='relative size-28 2xl:size-28 xl:size-28 lg:size-28 md:size-28 sm:size-28'>
              <svg
                className='size-full -rotate-90'
                viewBox='0 0 36 36'
                xmlns='http://www.w3.org/2000/svg'
              >
                <circle
                  cx='18'
                  cy='18'
                  r='16'
                  fill='none'
                  className='stroke-current text-[#20356A]'
                  strokeWidth='2'
                ></circle>
                <circle
                  cx='18'
                  cy='18'
                  r='16'
                  fill='none'
                  className='stroke-current text-gray-200'
                  strokeWidth='2.4'
                  strokeDasharray='100'
                  strokeDashoffset={`${uploadProgress}`}
                  strokeLinecap='round'
                ></circle>
              </svg>

              <div className='absolute top-1/2 start-1/2 transform -translate-y-1/2 -translate-x-1/2'>
                <span className='text-center text-2xl font-bold text-[#20356A]'>
                  {uploadProgress}%
                </span>
              </div>
            </div>
          </div>

          <div className='mt-4 flex items-center'>
            <div className='flex justify-center items-center'></div>
            <div className='flex-1'>
              <div className='h-2 bg-gray-300 rounded'>
                <div
                  className='h-2 bg-[#20356A] rounded'
                  style={{ width: `${uploadProgress}%` }}
                ></div>
              </div>
            </div>
          </div>

          <div className='mt-10 flex items-center justify-between'>
            <div>
              <h3 className='text-xl font-medium'>Upload Legal Documents</h3>
              <p className='text-gray-600'>Manage yours with books ease</p>
            </div>
            <div>
              <Button
                type='primary'
                onClick={handleClickRefresh}
                loading={isload}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {isload ? null : <RotateCcw />}
              </Button>
            </div>
          </div>

          <div className='grid grid-cols-1 xxl:grid-cols-4 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 gap-6 mt-6'>
            {data?.rc?.map((item: any) => (
              <div
                key={item?.documentId || item?.documentTypeId}
                className='bg-gray-100 rounded-lg p-4 border border-gray-200 flex  gap-4'
              >
                <div className='flex justify-center items-center bg-white w-16 h-16 rounded-md'>
                  <FileText stroke='#ccc' strokeWidth={1} size={42} />
                </div>

                <div className='w-9/12'>
                  <h4 className='text-lg font-medium leading-6'>
                    {item?.documentName?.trim()}
                  </h4>

                  {item?.status && (
                    <div className='mb-2'>
                      <StatusBadge status={item?.status} />
                    </div>
                  )}

                  {dayjs(item?.lastUpdatedDate).format && (
                    <dt className='text-xs text-gray-500 mt-2 mb-2'>
                      Last Updated:{' '}
                      {dayjs(item?.lastUpdatedDate).format('DD-MM-YYYY')}
                    </dt>
                  )}

                  {item?.reason && <div>Reason:{item?.reason}</div>}
                  {item?.reason && <div>Comments:{item?.comments}</div>}

                  <div className='dsbbuttongrp'>
                    <div className='errrbx'>
                      {item?.reason && <h4>{item?.reason}</h4>}
                    </div>
                    <div className='butnbx'>
                      {item?.status !== 'Pending' &&
                        item?.status !== 'Approved' && (
                          <button
                            className='btn'
                            onClick={() => {
                              setShowModal(true);
                              setTitleDocuments(item as any);
                            }}
                            // className='bg-blue-900 text-white border-none text-xs btn-sm p-3 py-2 hover:bg-blue-950 hover:text-white! rounded-md'
                          >
                            Upload
                          </button>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DashBoardView;
